export default __webpack_public_path__ + "static/media/trophy-icon.2d1ac8f8.svg";